
//swiper slide
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

import './styles.css'

export default function Load() {
    return(
        <Swiper>
            <SwiperSlide>
                <div className='cast-loading'>
                    <div className='img'></div>
                    <div className='name'></div>
                    <div className='character-name'></div>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className='cast-loading'>
                    <div className='img'></div>
                    <div className='name'></div>
                    <div className='character-name'></div>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className='cast-loading'>
                    <div className='img'></div>
                    <div className='name'></div>
                    <div className='character-name'></div>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className='cast-loading'>
                    <div className='img'></div>
                    <div className='name'></div>
                    <div className='character-name'></div>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className='cast-loading'>
                    <div className='img'></div>
                    <div className='name'></div>
                    <div className='character-name'></div>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className='cast-loading'>
                    <div className='img'></div>
                    <div className='name'></div>
                    <div className='character-name'></div>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className='cast-loading'>
                    <div className='img'></div>
                    <div className='name'></div>
                    <div className='character-name'></div>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className='cast-loading'>
                    <div className='img'></div>
                    <div className='name'></div>
                    <div className='character-name'></div>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className='cast-loading'>
                    <div className='img'></div>
                    <div className='name'></div>
                    <div className='character-name'></div>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className='cast-loading'>
                    <div className='img'></div>
                    <div className='name'></div>
                    <div className='character-name'></div>
                </div>
            </SwiperSlide>
        </Swiper>
    )
}